/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Sidebar from '../../components/Sidebar';
import Header from '../../components/Header';
import { CustomTable } from '../../components/Table';
import { Button, Modal, Popover, Tag, Tooltip, Avatar } from 'antd';
import { GetRoleListWithPaginationAction } from '../../store/Actions/RolesAction';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { ExclamationCircleFilled, UserOutlined, SafetyCertificateOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { plusicon, refreshicon } from '../../components/imagepath';
import { ActionDeleteById } from '../../store/Actions/CommonAction';
import { matchPermissions } from '../../utils/Permission';
import { PERMISSIONS } from '../../constants';
const { confirm } = Modal;

const Roles = () => {
  const [EditMembersModal, SetEditMembersModal] = useState(false);
  const dispatch = useDispatch();
  const { RoleList_Pagination, loader } = useSelector(state => state?.Role);
  const { userDetails } = useSelector(state => state?.auth);
  const [Refresh, setRefresh] = useState(false);
  const matchPermissionsForUser = matchPermissions(userDetails);
  const canView = matchPermissionsForUser(PERMISSIONS.ROLES.VIEW);
  const canUpdate = matchPermissionsForUser(PERMISSIONS.ROLES.UPDATE);
  const canDelete = matchPermissionsForUser(PERMISSIONS.ROLES.DELETE);
  const canCerate = matchPermissionsForUser(PERMISSIONS.ROLES.CREATE);
  useEffect(() => {
    dispatch(GetRoleListWithPaginationAction({ Query: '' }));
    setRefresh(false);
  }, [Refresh]);
  const content = item => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', minWidth: '120px' }}>
      {canUpdate && (
        <Button
          type="text"
          icon={<EditOutlined />}
          style={{ textAlign: 'left', justifyContent: 'flex-start' }}
          onClick={() => {
            window.location.href = `roles/create-roles?update=true&&page=${1}&&id=${item?.id}`;
          }}
        >
          Edit Role
        </Button>
      )}
      {canDelete && (
        <Button
          type="text"
          danger
          icon={<DeleteOutlined />}
          style={{ textAlign: 'left', justifyContent: 'flex-start' }}
          onClick={() => showDeleteConfirm(item)}
        >
          Delete Role
        </Button>
      )}
    </div>
  );
  // /roles/create-roles
  const showDeleteConfirm = item => {
    confirm({
      title: `Are you sure delete this ${item?.roleName} Role?`,
      icon: <ExclamationCircleFilled />,
      content: '',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      zIndex: 1200,
      centered: true,
      onOk() {
        dispatch(
          ActionDeleteById({ Query: `admin/roles/${item?.id}` }, Res => {
            if (Res?.statusCode === 200) {
              setRefresh(true);
            }
          })
        );
      },
      onCancel() {
        return
      },
    });
  };

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'index',
      width: 80,
      render: (_, __, index) => (
        <span style={{ fontWeight: '500', color: '#666' }}>{index + 1}</span>
      ),
    },
    {
      title: 'Role Name',
      dataIndex: 'roleName',
      render: (text) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <SafetyCertificateOutlined style={{ fontSize: '18px', color: '#1890ff' }} />
          <span style={{ fontWeight: '600', fontSize: '14px' }}>{text}</span>
        </div>
      ),
    },
    {
      title: 'Permissions',
      dataIndex: 'permission',
      render: (permission) => {
        const permissionCount = permission?.length || 0;
        return (
          <Tooltip title={permissionCount > 0 ? `${permissionCount} permissions assigned` : 'No permissions assigned'}>
            <Tag
              color={permissionCount > 10 ? 'green' : permissionCount > 5 ? 'blue' : permissionCount > 0 ? 'orange' : 'default'}
              style={{ borderRadius: '12px', padding: '2px 12px' }}
            >
              {permissionCount} {permissionCount === 1 ? 'Permission' : 'Permissions'}
            </Tag>
          </Tooltip>
        );
      },
    },
    {
      title: 'Assigned Users',
      dataIndex: 'adminUsers',
      render: adminUsers => {
        const userCount = adminUsers?.length || 0;
        if (userCount === 0) {
          return (
            <span style={{ color: '#999', fontStyle: 'italic' }}>No users assigned</span>
          );
        }
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Avatar.Group
              max={{
                count: 4,
                style: { color: '#f56a00', backgroundColor: '#fde3cf' },
              }}
            >
              {adminUsers?.map((user, index) => (
                <Tooltip key={index} title={user?.name || 'User'} placement="top">
                  <Avatar
                    style={{
                      backgroundColor: getAvatarColor(index),
                      cursor: 'pointer'
                    }}
                  >
                    {user?.name?.charAt(0)?.toUpperCase() || 'U'}
                  </Avatar>
                </Tooltip>
              ))}
            </Avatar.Group>
            <Tag color="blue" style={{ marginLeft: '4px', borderRadius: '10px' }}>
              {userCount} {userCount === 1 ? 'User' : 'Users'}
            </Tag>
          </div>
        );
      },
    },
    {
      title: 'Status',
      dataIndex: 'isActive',
      width: 100,
      render: (isActive) => (
        <Tag color={isActive !== false ? 'success' : 'error'} style={{ borderRadius: '12px' }}>
          {isActive !== false ? 'Active' : 'Inactive'}
        </Tag>
      ),
    },
    {
      title: 'Actions',
      dataIndex: 'roleName',
      width: 100,
      render: (text, record) => {
        if (!canUpdate && !canDelete) {
          return null;
        } else {
          return (
            <Popover placement="left" title={`Manage: ${text}`} content={() => content(record)} trigger="click">
              <Button type="text" style={{ fontWeight: 'bold', fontSize: '16px' }}>• • •</Button>
            </Popover>
          );
        }
      },
    },
  ];

  // Helper function to generate avatar colors
  const getAvatarColor = (index) => {
    const colors = ['#f56a00', '#7265e6', '#ffbf00', '#00a2ae', '#87d068', '#1890ff'];
    return colors[index % colors.length];
  };
  return (
    <>
      <Header />
      <Sidebar />
      <>
        <div>
          <div className="page-wrapper">
            <div className="content">
              {/* Page Header */}
              <div className="page-header">
                <div className="row">
                  <div className="col-sm-12">
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link>Roles</Link>
                      </li>
                      <li className="breadcrumb-item">
                        <i className="feather-chevron-right">
                          <FeatherIcon icon="chevron-right" />
                        </i>
                      </li>
                      <li className="breadcrumb-item active">Roles List</li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              {/* Summary Stats */}
              <div className="row mb-4">
                <div className="col-md-4">
                  <div className="card" style={{ borderLeft: '4px solid #1890ff' }}>
                    <div className="card-body d-flex align-items-center">
                      <SafetyCertificateOutlined style={{ fontSize: '32px', color: '#1890ff', marginRight: '15px' }} />
                      <div>
                        <h3 style={{ margin: 0, fontWeight: '600' }}>
                          {RoleList_Pagination?.[0]?.docs?.length || 0}
                        </h3>
                        <p style={{ margin: 0, color: '#666' }}>Total Roles</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card" style={{ borderLeft: '4px solid #52c41a' }}>
                    <div className="card-body d-flex align-items-center">
                      <UserOutlined style={{ fontSize: '32px', color: '#52c41a', marginRight: '15px' }} />
                      <div>
                        <h3 style={{ margin: 0, fontWeight: '600' }}>
                          {RoleList_Pagination?.[0]?.docs?.reduce((acc, role) => acc + (role?.adminUsers?.length || 0), 0) || 0}
                        </h3>
                        <p style={{ margin: 0, color: '#666' }}>Users with Roles</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card" style={{ borderLeft: '4px solid #faad14' }}>
                    <div className="card-body d-flex align-items-center">
                      <SafetyCertificateOutlined style={{ fontSize: '32px', color: '#faad14', marginRight: '15px' }} />
                      <div>
                        <h3 style={{ margin: 0, fontWeight: '600' }}>
                          {RoleList_Pagination?.[0]?.docs?.filter(role => (role?.adminUsers?.length || 0) === 0)?.length || 0}
                        </h3>
                        <p style={{ margin: 0, color: '#666' }}>Unassigned Roles</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Summary Stats */}
              <div className="row">
                <div className="col-sm-12">
                  <div className="card card-table show-entire">
                    <div className="card-body">
                      {/* Table Header */}
                      <div className="page-table-header mb-2">
                        <div className="row align-items-center">
                          <div className="col">
                            <div className="doctor-table-blk">
                              <h3>Roles Management</h3>
                              <div className="doctor-search-blk">
                                <div className="add-group">
                                  {canCerate && (
                                    <Tooltip title="Create New Role">
                                      <Link
                                        to="/roles/create-roles"
                                        className="btn btn-primary add-pluss ms-2"
                                      >
                                        <img src={plusicon} alt="Add" />
                                      </Link>
                                    </Tooltip>
                                  )}

                                  <Tooltip title="Refresh List">
                                    <Link
                                      onClick={() => window.location.reload()}
                                      className="btn btn-primary doctor-refresh ms-2"
                                    >
                                      <img src={refreshicon} alt="Refresh" />
                                    </Link>
                                  </Tooltip>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="table-responsive">
                        {canView ? (
                          <>
                            <CustomTable
                              CurrentPageNum={1}
                              TotalPageList={1}
                              column={columns}
                              dataSource={
                                RoleList_Pagination?.[0]?.docs ? RoleList_Pagination?.[0]?.docs : []
                              }
                              dataSourceLength={5}
                              pageSize={10}
                              loader={loader}
                              ShowHeader={true}
                              Header={<div className="staff-search-table"></div>}
                              key={'hi'}
                            />

                            <Modal
                              open={EditMembersModal}
                              closable={true}
                              className="ant-modal"
                              forceRender={true}
                              zIndex={900}
                              style={{ margin: 10 }}
                              onOk={() => SetEditMembersModal(false)}
                              styles={{
                                body: {
                                  overflow: 'hidden',
                                },
                                mask: {
                                  backdropFilter: 'blur(10px)',
                                },
                                content: {
                                  borderRadius: 40,
                                },
                              }}
                              okText={'Submit'}
                              centered
                              confirmLoading={false}
                              onCancel={() => SetEditMembersModal(false)}
                              closeIcon={true}
                            ></Modal>
                          </>
                        ) : (
                          <div className="permission-denied-message">
                            You do not have permission to view roles management.
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};
export default Roles;
